import React from 'react';
import { Crown } from 'lucide-react';
import { useDisplayPrice } from '../../lib/stripe';

interface PremiumButtonProps {
  onClick: () => void;
}

export function PremiumButton({ onClick }: PremiumButtonProps) {
  const displayPrice = useDisplayPrice();
  return (
    <div className="p-4 border-t border-gray-200 dark:border-gray-700">
      <div className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white p-4 rounded-lg shadow-lg">
        <h3 className="text-lg font-semibold mb-2">Upgrade to Premium</h3>
        <p className="text-sm mb-4">Get unlimited cycles and custom sounds for just ${displayPrice ?? import.meta.env.VITE_PRICE_LIFETIME}</p>
        <button
          onClick={onClick}
          className="w-full bg-white text-indigo-600 font-medium py-2 px-4 rounded-md hover:bg-gray-50 transition-colors flex items-center justify-center"
        >
          <Crown className="w-5 h-5 mr-2" />
          Upgrade Now
        </button>
      </div>
    </div>
  );
}